import { Form } from 'antd'

import PageWrap from '../../components/layout/PageWrap'
import FormWrap from '../../components/forms/FormWrap'
import FormBlock from '../../components/forms/FormBlock'

import { TypeDescription } from '../../constants/forms/ProductTypes'
import { CreateProductType as request } from '../../network/ProductTypes'

const CreateProductType = () => {
    const [form] = Form.useForm()

    return (
        <PageWrap goBack title="PRODUCT_TYPES_CREATE_TYPE">
            <FormWrap
                title="create_product_type"
                request={request}
                onSuccess={'/product-types'}
                onCancel={'/product-types'}
                invalidate={['getProductTypesList']}
            >
                <div className="SectionVerticalWrap">
                    <FormBlock form={form} formTemplate={TypeDescription} />
                </div>
            </FormWrap>
        </PageWrap>
    )
}

export default CreateProductType
